import trackAnalytics from '../../utils/gaia/trackAnalytics';
import React from 'react';
import {CircularProgress, Dialog, DialogActions, Button} from '@material-ui/core';

interface OfflineMapGuideDialogProps {
    open: boolean;
    onRequestClose: () => void;
    buttonTitle: string | undefined;
    showingDownload: boolean | undefined;
    description: string;
    saved: boolean;
}

/**
 * OfflineMapGuideDialog component for saving a map object to Gaia GPS.
 * Material-UI Dialog.
 *
 * ---------------------------
 * | Title            Buttons |
 * ---------------------------
 * | Checklist                |
 * ---------------------------
 */
export default class OfflineMapGuideDialog extends React.Component<OfflineMapGuideDialogProps, {}> {
    render() {
        return (
            <Dialog
                open={this.props.open}
                onClose={this.props.onRequestClose}
            >
                <div style={{textAlign: 'center', fontSize: '18px', maxWidth: 420}}>
                    <DialogActions>
                        {this.props.buttonTitle && <Button
                            key='titleButton'
                            variant='text'
                            color='primary'
                            onClick={this.props.onRequestClose}
                        >
                            {this.props.buttonTitle}
                        </Button>}
                    </DialogActions>
                    <div
                        style={{margin: 30}}
                        dangerouslySetInnerHTML={{__html: this.props.description}}
                    />
                    <div style={{marginBottom: 20}}>
                        { this.props.showingDownload && (
                            <div style={{marginLeft: 8, marginTop: 20}}>
                                <a
                                    // eslint-disable-next-line max-len
                                    href="https://itunes.apple.com/us/app/gaia-gps/id1201979492?mt=8&uo=4"
                                    // eslint-disable-next-line max-len
                                    onClick={() => trackAnalytics('Download App Store', {
                                        category: 'Hike',
                                        url: window.location.pathname
                                    })}
                                >
                                    <img src="/static/img/appstore.svg" width="145" height="43" />
                                </a>
                                &nbsp;&nbsp;&nbsp;
                                <a
                                    // eslint-disable-next-line max-len
                                    href="https://market.android.com/details?id=com.trailbehind.android.gaiagps.pro&hl=en"
                                    // eslint-disable-next-line max-len
                                    onClick={() => trackAnalytics('Download Play Store', {
                                        category: 'Hike',
                                        url: window.location.pathname
                                    })}
                                >
                                    <img
                                        src="/static/img/icons/play_badge.png"
                                        width="145"
                                        height="43"
                                        alt=""
                                        style={{marginLeft: 3}}
                                    />
                                </a>
                            </div>
                        )}
                        <div>
                            { !this.props.showingDownload && (
                                this.props.saved ?
                                    <i
                                        className="ibmid material-icons md-green"
                                        style={{marginRight: 10, fontSize: '48px'}}
                                    >
                                        done
                                    </i> :
                                    <span><CircularProgress
                                        size={48}
                                        color='primary'
                                        style={{marginRight: 10}}
                                    /></span>
                            )}
                        </div>
                    </div>
                </div>
            </Dialog>
        );
    }
}
